// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
// import SideMenu from "@store/Library/Components/Toolkit/SideMenu"; // bunzl custom code
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

/* bunzl custom code start */
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import SideMenu, { SideMenuStyles } from "@store/Library/Components/Toolkit/SideMenu";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import * as cssLinter from "css";
/* bunzl custom code end */
enum fields {
    customCSS = "customCSS",
    // Store Custom Code
    hideTitle = "hideTitle",
}
export interface MyAccountSideMenuStyles {
    wrapper?: InjectableCss;
    /* bunzl custom code start */
    sideMenuStyles?: SideMenuStyles;
    title: InjectableCss;
    /* bunzl custom code end */
}

export const myAccountSideMenuStyles: MyAccountSideMenuStyles = {
    /* bunzl custom code start */
    sideMenuStyles: {
        list: {
            css: css`
                background-color: ${getColor("common.shadesLight")};
            `,
        },
        listItem: {
            css: css`
                margin-bottom: 0;
            `,
        },
        activeStyles: {
            css: css`
                border-left: none;
                border-right: none;
                color: ${getColor("primary")};
                font-size: ${({ theme }) => theme.design.typography.size.large};
                font-weight: ${({ theme }) => theme.design.typography.weight.bold};
            `,
        },
        link: {
            css: css`
                border-left: none;
                border-right: none;
                background-color: ${getColor("common.shadesLight")};
                font-size: ${({ theme }) => theme.design.typography.size.large};
                color: ${getColor("text.accent")};
                font-weight: ${({ theme }) => theme.design.typography.weight.bold};
                padding-block: ${pxToRem(16)};
                padding-left: 0;
                &:not(:focus-visible) {
                    outline: none;
                }
            `,
        },
    },
    title: {
        css: css`
            margin-bottom: ${pxToRem(36)};
        `,
    },
    wrapper: {
        css: css`
            ${spacingStyles()}
            width: 100%;
            padding: ${pxToRem(64, 24, 24, 64)};
            background-color: ${getColor("common.shadesLight")};
        `,
    },
    /* bunzl custom code end */
};

const styles = myAccountSideMenuStyles;
interface OwnProps extends WidgetProps {
    fields: {
        [fields.customCSS]: string;
        // Store Custom Code
        [fields.hideTitle]: boolean;
    };
}
/* bunzl custom code start */
const MyAccountSideMenu: FC<OwnProps> = ({ fields: { customCSS, hideTitle } }) => {
    const link = usePageLinkByPageType(constants.pageType.myAccount);
    const customCssWrapper = {
        css: css`
            ${customCSS}
        `,
    };

    return (
        <StyledWrapper {...customCssWrapper}>
            <StyledWrapper {...styles.wrapper} className="sidemenu-widget-wrapper">
                {!hideTitle && (
                    <Typography className="sidemenu-title" as="h1" variant="h3" {...styles.title}>
                        {link?.title}
                    </Typography>
                )}
                <SideMenu
                    pageType={constants.pageType.myAccount}
                    extendedStyles={styles.sideMenuStyles}
                    showRootPage
                    showSignOut
                />
            </StyledWrapper>
        </StyledWrapper>
    );
};
const defaultCustomCss = `.sidemenu-widget-wrapper {
}
.sidemenu-title {
}
.sidemenu-wrapper {
}
.sidemenu-list {
}
.sidemenu-listitem {
}
.sidemenu-link {
}
.sidemenu-link.active {
}
`;

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 2,
};

const widgetModule: WidgetModule = {
    component: MyAccountSideMenu,
    definition: {
        group: "My Account",
        icon: "NavigationList",
        displayName: "Account Menu",
        fieldDefinitions: [
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            {
                name: fields.hideTitle,
                displayName: "Hide Title",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
            },
        ],
    },
};
/* bunzl custom code end */

export default widgetModule;
